import React, { useState, useEffect, useCallback } from 'react';
import { promptMenuPluginKey } from '../../editor-core';

function usePromptMenuPlugin(
  editorReady,
  editorViewRef,
  editorState
) {
  const [showPrompt, setShowPrompt] = useState(null);
  const plugin =
    editorViewRef.current && editorViewRef.current.pluginViews
      ? editorViewRef.current.pluginViews.find(p => p.name === 'prompt-menu-plugin')
      : {};
  const pluginState = editorState && promptMenuPluginKey.getState(editorState);

  const closePrompt = useCallback(
    (event) => {
      event.preventDefault();
      plugin.close();
      setShowPrompt(null);
    },
    [plugin]
  );

  const handleEscape = useCallback(
    (event) => {
      // tslint:disable-next-line: deprecation
      if (event.keyCode === 27) {
        closePrompt(event);
      }
    },
    [closePrompt]
  );

  useEffect(() => {
    const bind = () => {
      document.addEventListener('keydown', handleEscape, false);
    };
    const teardown = () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
    if (editorReady) {
      const pluginItem = plugin.items.find(item => item.name === pluginState.open.type);
      if (pluginItem) {
        setShowPrompt({
          item: pluginItem,
          existingAttrs: pluginState.open.attrs || {},
          plugin
        });
        bind();
      } else {
        setShowPrompt(null);
        teardown();
      }
    }

    return teardown;
  }, [handleEscape, pluginState && pluginState.open]);

  return { showPrompt, closePrompt };
}

export default usePromptMenuPlugin;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/hooks/usePromptMenuPlugin.js